<template lang="pug">
  v-content
    VideoAndNews#news
    IntroAndResults#about
    .issuuembed(data-configid='30762754/70507072', style='width:100%; height: 100vh;')
    Rights#content.rights
    PublicIssueEngagement#public
    Illustration#illustration
    EighteenVoteRight#eighteen
    TaiwanVoteTypes#taiwan
    OnlineEducation#online
    HighschoolvoteAndVideo#student
    FAQ#faq
</template>

<script>
import VideoAndNews from "../components/VideoAndNews";
import IntroAndResults from "../components/IntroAndResults";
import Rights from "../components/Rights";
import Carousel from "../components/Carousel";
import PublicIssueEngagement from "../components/PublicIssueEngagement";
import Illustration from "../components/Illustration";
import EighteenVoteRight from "../components/EighteenVoteRight";
import TaiwanVoteTypes from "../components/TaiwanVoteTypes";
import OnlineEducation from "../components/OnlineEducation";
import HighschoolvoteAndVideo from "../components/HighschoolvoteAndVideo";
import FAQ from "../components/FAQ";

export default {
  components: {
    VideoAndNews,
    IntroAndResults,
    Rights,
    Carousel,
    PublicIssueEngagement,
    Illustration,
    EighteenVoteRight,
    TaiwanVoteTypes,
    OnlineEducation,
    HighschoolvoteAndVideo,
    FAQ
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans:400,400i,700,700i");
* {
  font-family: "Noto Sans", sans-serif;
  .content-all {
    font-size: 16px !important;
    line-height: 1.6 !important;
  }
  .title-all{
  font-size: 32px;
  color: #152147;
  font-weight: 700;
}
}

html,
body {
  width: 100vw;
  height: 100%;
}


.v-window__container{
  overflow: hidden;
}


.public-issue .v-card__text.issue-text,
.public-issue .v-card.v-sheet.theme--light {
  border-radius: 15px !important;
}

.public-issue .v-expansion-panel__header {
  flex-direction: column !important;
}

.carousel-wrapper i {
  color: gray !important;
}

#news,
#about,
#content,
#public,
#illustration,
#eighteen,
#taiwan,
#student,
#faq {
  min-height: 60vh;
}

#public{
  overflow: hidden;
}

.content-all a {
  text-decoration: none;
}

.v-content {
  background-color: #fff5bb;
  background-image: url("../assets/bkg_icons.svg");
  background-size: 100% auto;
  background-repeat: repeat;
}

.v-image__image--cover {
  background-size: contain !important;
}

.v-tip-container {
  max-width: 50vw;
  & > * {
    font-family: sans-serif;
    font-weight: bold;
  }
  .v-tip-title {
    font-size: 1.5em !important;
  }
  .v-tip-content {
    font-size: 1.2em !important;
    color: white !important;
    white-space: pre-line !important;
  }
}

.studentImages .v-image__image--cover {
  filter: contrast(100%) grayscale(10%) hue-rotate(-15deg) sepia(0%)
    saturate(100%);
  background-size: 100% auto !important;
  @media screen and (max-width: 480px) {
    background-size: auto 100% !important;
  }
}

.v-tabs__slider-wrapper{
  display: none;
}

.v-tabs__bar, .v-tabs__icon{
  padding-top: 20px;
}

a.v-tabs__item:not(.v-tabs__item--active){
  border-bottom: solid 3px rgba(0,0,0,0.5) !important;
  margin-right: 5px;
  margin-left: 5px;
  // border-right: solid 5px white !important;
  // background-color: red;
}

a.v-tabs__item--active{
  background-color: rgba(0,0,0,0.5) !important;
  color: white;
}
</style>
